import { Container, Paper, useMediaQuery, useTheme } from '@mui/material';
import { useContext, useEffect, useRef, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { getEventDetails, getPendingFormDetails } from '../../ApiServices/Api';
import { useApplicationContext } from '../../Helpers/Contexts/applicationContext';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import { getVisibleSteps } from '../../Helpers/applicationHelper';
import KenApplicationFormHeader from './Components/DescriptionHeader';
import CustomizedSteppers from './Components/KenStepperHeader';
import Stepper from './Stepper';
import AppLayout from '../../Components/AppLayout';
import { FORM_VALUES_NATIONALITY } from '../../Helpers/formValueHelper';
import Loader from '../../Components/Loaders';

export default function KenApplication() {
  const navigate = useNavigate();
  const formRef = useRef();
  const urlSearch = useLocation().search;
  const {
    state: { user },
  } = useContext(AuthContext);
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { applicationState, applicationDispatch } = useApplicationContext();
  const { applicationId, applicationData, form, formId, steps = [], activeStep, showHeader } = applicationState;

  const [isDataFetched, setDataFetched] = useState();
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (steps[activeStep] && applicationId && applicationData && form) {
      setDataFetched(true);
    }
  }, [steps, activeStep, applicationId, applicationData, form]);

  const updateState = (payload) => {
    applicationDispatch({ type: 'update', payload });
  };

  const alertMessage = (message) => {
    console.log('alert:', message);
  };

  useEffect(() => {
    updateState({ applicantId: user?.applicantId });
  }, [user]);

  useEffect(() => {
    const query = new URLSearchParams(urlSearch);
    const tempId = query.get('formId');
    if (tempId && tempId !== 'null' && tempId !== 'undefined') {
      updateState({ formId: tempId });
    } else {
      alertMessage('Invalid formId. Try again');
    }
    const id = query.get('applicationId');
    if (id) {
      updateState({ applicationId: id });
    }
  }, [urlSearch]);

  const goToDashboard = () => {
    navigate('/home');
  };

  useEffect(() => {
    if (!formId) {
      return;
    }

    setLoader(true);
    getEventDetails(formId)
      .then((res) => {
        if (res?.data?.status) {
          const { formMetadata } = res?.data?.result?.data;
          const steps = getVisibleSteps(formMetadata);
          updateState({
            form: { ...res?.data?.result?.data },
            steps,
            totalSteps: steps.length,
            ...(applicationId ? {} : { activeStep: 0 }),
            formOptions: {
              nationality: [...FORM_VALUES_NATIONALITY],
            },
          });
        } else {
          alertMessage('Refresh and try again');
        }
        setLoader(false);
      })
      .catch((err) => {
        const { reponse: { status, data } = {} } = err;
        console.log('form err: ', err);
        if (status === 400) {
          alertMessage('Invalid form Try again');
        }
        setLoader(false);
      });
  }, [formId]);

  useEffect(() => {
    if (!applicationId) {
      return;
    }

    setLoader(true);
    getPendingFormDetails(applicationId)
      .then((res) => {
        const query = new URLSearchParams(urlSearch);
        const currentStep = query.get('currentStep');
        const customData = { ...res?.data?.result?.data };

        // (customData['teamMembers'] || []).forEach((items) => {
        //   items['LastName'] = items['Name'];
        //   return items;
        // });

        if (res?.data?.status) {
          updateState({
            applicationData: customData,
            activeStep: currentStep && currentStep !== 'null' && currentStep !== 'undefined' ? parseInt(currentStep) : parseInt(res?.data?.result?.data?.application?.Current_Step__c) || 0,
          });
        }
        setLoader(false);
      })
      .catch((err) => {
        const { response: { status, data: { errorMessages = [] } = {} } = {} } = err;
        if (status === 400 && errorMessages?.length > 0) {
          const errObj = errorMessages.find((el) => (el.errorMessage = 'Wrong application Id.'));
          if (errObj) {
            goToDashboard();
            alertMessage('Application Invalid');
          }
        }
        setLoader(false);
      });
  }, [applicationId]);

  return (
    <>
      {loader ? (
        <Loader />
      ) : (<>
        <AppLayout>
          <Paper sx={{ borderRadius: '12px', overflow: "hidden" }}>
            {showHeader && !isMobileScreen && (
              <>
                {form?.programName !== null ? (
                  <KenApplicationFormHeader programName={form?.programName} duration={form?.courseDuration} batch={form?.courseBatch} endDate={form?.endDate} form={form} />
                ) : (
                  <Skeleton
                    height="8px"
                    style={{
                      marginTop: '70px',
                      marginBottom: '20px',
                      background: '#F6C445',
                    }}
                  />
                )}
              </>
            )}
            {isDataFetched && (
              <>
                <CustomizedSteppers alternativeLabel={isMobileScreen} activeStep={activeStep} steps={steps} />
                <Stepper step={steps[activeStep]} formRef={formRef} />
              </>
            )}
            {(applicationId && !applicationData) ||
              (loader && (
                <Container maxWidth="md" style={{ textAlign: 'start' }}>
                  <Skeleton width="40%" height="30px" style={{ marginTop: '50px', marginBottom: '20px' }} />
                  <Skeleton count={2} inline width="45%" wrapper={({ children }) => <span style={{ marginRight: '0.5rem' }}>{children}</span>} />
                  <Skeleton width="40%" height="30px" style={{ marginTop: '50px', marginBottom: '20px' }} />
                  <Skeleton count={2} inline width="45%" wrapper={({ children }) => <span style={{ marginRight: '0.5rem' }}>{children}</span>} />
                </Container>
              ))}
          </Paper>
        </AppLayout>
      </>)}
    </>
  );
}
